import {
  slab, wallZ, wallX, goal, sign, neon, checkpoint, edgeLights,
  ring, bouncefloor, gravfield, speedgate,
} from '../kit.js';

/**
 * The compound sector. Three chapters, each fusing two learned mechanics:
 * bounce INTO a ring, fling THROUGH low gravity THROUGH a speed gate, then
 * a bounce-ring-bounce rhythm run to the goal. Nothing here is new; the
 * level is the combinations.
 */
export default {
  id: 'conflux',
  name: 'CONFLUX',
  blurb: 'Everything you know. All at once.',
  mode: { type: 'sprint', par: 30 },
  redline: { seconds: 19 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 24.4, 6], yaw: 0 },
  killY: -60,
  env: {
    fog: 0x14101e,
    fogDensity: 0.0038,
    sky: { zenith: 0x060410, horizon: 0x241536, glow: 0x8a4ad8, aurora: 0x3cf3c8 },
    floorY: -240,
  },
  objects: [
    // ================= chapter one: bounce into the ring =================
    slab(0, 24, 0, 22, 22, 'plate', 1.4),
    ...edgeLights(0, 24, 0, 22, 22, 'cyan'),
    checkpoint(0, 24, 6),
    sign(0, 27.2, 5, 0, ['CONFLUX', 'EVERYTHING YOU KNOW', 'ALL AT ONCE'], '#3cf3c8'),

    // fall 24 onto the kinetic floor; the bounce rises through a ring that
    // throws you at terrace one
    bouncefloor(0, 0, -20, 16, 16),
    ring(0, 18, -28, [0, 0.15, -0.99], 16, 3),
    slab(0, 16, -62, 24, 20, 'plate', 1.4),
    ...edgeLights(0, 16, -62, 24, 20, 'lime'),
    checkpoint(0, 16, -58),
    sign(0, 19.2, -59, 0, ['PORTAL THE PIT', 'THE WALL FACES THE LIGHT', 'CARRY SPEED THROUGH THE GATE'], '#ffb020'),

    // ================= chapter two: hot light =================
    // The pit under the terrace lip: 46m of fall becomes 45 m/s out of the
    // exit wall, and the aurora field keeps the flight flat enough to carry
    // it through the 40 gate hanging in the light.
    // The near wall sits UNDER the terrace lip (freefall's tuck): its plane
    // is behind the edge, so a shot over the lip never crosses it. A wall
    // placed beyond the edge with its top at deck level is a parapet, and a
    // parapet blocks every downward ray there is.
    wallZ(0, -30, -71.25, 20, 46, 'plate', 1.5),
    wallZ(0, -30, -95.75, 20, 34, 'plate', 1.5),     // stops low; the fling clears it
    wallX(-10.25, -30, -83.5, 24, 46, 'plate', 1.5),
    wallX(10.25, -30, -83.5, 24, 46, 'plate', 1.5),
    slab(0, -30, -83, 18, 24, 'panel', 1.5),
    neon(0, -29.4, -83, [16, 0.14, 0.14], 'magenta'),
    wallZ(0, 16, -66, 18, 12, 'panel', 1.4),
    neon(0, 28.4, -66.7, [18, 0.14, 0.14], 'cyan'),

    // The field's floor sits at y4: the flight enters at ~19 and sinks a
    // few metres crossing; a field bottom at deck height drops the body out
    // of the light mid-chasm and full gravity eats the last ten metres.
    gravfield(0, 4, -104, 26, 30, 62),
    speedgate(0, 10, -110, 26, 20, 40),

    // Catch the low mixed-frame trajectory before it sinks below y5.
    // Keep the far edge at -166 so the drums retain their entry drop.
    slab(0, 5, -146, 26, 40, 'plate', 1.4),
    ...edgeLights(0, 5, -146, 26, 40, 'lime'),
    checkpoint(0, 5, -140),
    sign(0, 8.2, -141, 0, ['THE DRUMS', 'BOUNCE. RING. BOUNCE. FLY.'], '#b28aff'),

    // ================= chapter three: the drums =================
    // The drums are tuned to a 24m entry fall; they moved down with the
    // terrace to keep that number.
    bouncefloor(0, -19, -180, 16, 18),
    ring(0, -5, -181, [0, 0.1, -0.99], 14, 3.4),
    // Wide drum: a frame hitch shifts the sixty-metre flight by metres,
    // and the landing pad forgives all of them.
    bouncefloor(0, -28, -242, 20, 28),
    neon(0, -27.2, -242, [18, 0.14, 0.14], 'lime'),

    // the second bounce arrives at ~42 m/s and returns it all: a skyward
    // launch that carries the last eighty metres
    slab(0, -6, -292, 30, 48, 'plate', 1.6),
    ...edgeLights(0, -6, -292, 30, 48, 'cyan'),
    checkpoint(0, -6, -284),
    goal(0, -6, -296, 0),
  ],
};
